import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ServicosIniciaisService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getEscopos(){
    return this.http.get(this.baseUrl + `/v1/escopos?page=0&size=10&sortField=nome&sortDirection=asc`);
  }
  getTipoServicos(){
    return this.http.get(this.baseUrl + `/v1/tipos-servico?page=0&size=10&sortField=nome&sortDirection=asc`);
  }

  getServicosIniciais(
    pageSize: number = 10,
    pageIndex:any,
    sortDirection:any,
    sortProperty:any,
    idContrato: string | null,
    filterParametro: string | null,
    filterData:any | null,
  ){
    let params = new HttpParams()
          .set('page', pageIndex?.toString() || '0')
          .set('size', pageSize)
          .set('sortField', sortProperty || '')
          .set('sortDirection', sortDirection || '')
          .set('nomeEscopo', filterData?.value?.nomeEscopo || '')
          .set('nomeTipoServico', filterData?.value?.nomeTipoServico || '')
          .set('parametroDesempenho', filterParametro || '')
          .set('inicioPrazoAtendimento', filterData?.value?.inicioPrazoAtendimento || '')
          .set('medidaInicioPrazoAtendimento', filterData?.value?.medidaInicioPrazoAtendimento || '')
          .set('fimPrazoAtendimento', filterData?.value?.fimPrazoAtendimento || '')
          .set('valor', filterData?.value?.valor || '')
          .set('medidaValor', filterData?.value?.medidaValor || '')

    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-iniciais`, { params });
  }
  getServicoInicial(idContrato:any, idParametroServicoInicial:any){
    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-iniciais/${idParametroServicoInicial}`);
  }
  create(data:any,  idContrato: string | null){
    return this.http.post(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-iniciais`, { ...data });
  }
  edit(data:any,  idContrato: string | null, idServicoInicial: string | null){
    return this.http.put(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-iniciais/${idServicoInicial}`, data );
  }
  getHistorico(id: string | null, idContrato: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/contratos/${idContrato}/parametros-servicos-iniciais/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
  deleteServico(id:any,contractId: any) {
    return this.http.delete(this.baseUrl + `/v1/contratos/${contractId}/parametros-servicos-iniciais/${id}`);
  }

  validateImport(contractId: any, data:any) {
    const formData = new FormData();
    formData.append('objetoOriginal', data?.file);
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-iniciais/validar-importacao`, formData)
  }

  import(contractId: any, data:any, file:any, cpnj: any) {
    const formData = new FormData();
    const registrosValidosBlob = new Blob(
      [JSON.stringify(data?.registrosValidos)],
      { type: 'application/json' }
    );
    formData.append('registrosValidos', registrosValidosBlob);
    formData.append('nomeArquivo', file?.name);
    const fileExtension = file.type.split('/')[1];
    formData.append('tipoMime', fileExtension);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('subCategoria', cpnj);
    formData.append('objetoOriginal', file?.file);
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-iniciais/importar`, formData)
  }
}
